import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useSelectedDevices } from '../utils/media';
import { AudioDeviceList, VideoDeviceList } from './DeviceList';
import { DownCaret, SmallCameraIcon, SmallMicrophoneIcon } from './Icon';
import { PopupButton } from './PopupButton';
export function DeviceDropdown({ kind, isOpen, setIsOpen, }) {
    const rootRef = useRef(null);
    useEffect(() => {
        function onMouseDown(e) {
            if (!(e.target instanceof Element) || !rootRef.current) {
                return;
            }
            if (rootRef.current.contains(e.target)) {
                return;
            }
            setIsOpen?.(false);
        }
        window.addEventListener('mousedown', onMouseDown);
        function onKeyDown(e) {
            if (e.key === 'Escape') {
                setIsOpen?.(false);
            }
        }
        window.addEventListener('keydown', onKeyDown);
        return () => {
            window.removeEventListener('keydown', onKeyDown);
            window.removeEventListener('mousedown', onMouseDown);
        };
    }, [setIsOpen]);
    const { [kind]: currentDevice } = useSelectedDevices();
    return (_jsxs(DropdownRoot, { ref: rootRef, children: [_jsx(PopupButton, { type: "button", onClick: () => {
                    setIsOpen?.((c) => !c);
                }, active: isOpen, prependComponent: kind === 'audio' ? (_jsx(SmallMicrophoneIcon, {})) : (_jsx(SmallCameraIcon, {})), appendComponent: _jsx(DownCaret, { size: "1.25rem" }), children: currentDevice ? (currentDevice.label || 'N/A') : (_jsxs(_Fragment, { children: ["Select ", kind, " input\u2026"] })) }), isOpen && (_jsxs(DropdownMenu, { children: [kind === 'audio' && (_jsx(AudioDeviceList, { onDeviceSelect: () => {
                            setIsOpen?.(false);
                        } })), kind === 'video' && (_jsx(VideoDeviceList, { onDeviceSelect: () => {
                            setIsOpen?.(false);
                        } }))] }))] }));
}
const DropdownMenu = styled.div `
    position: absolute;
    top: 100%;
    transform: translateY(0.5rem);
    left: 0;
    width: 100%;
    z-index: 1;
`;
const DropdownRoot = styled.div `
    position: relative;
`;
